
{
  "header": "\"{title}\" Submissions",
  "subheader": "View the submissions people have submitted to your form.",
  "view-form": "View Form",
  "export": "Export Submissions",
  "export-error": "Could not export submissions."
}
